import { slice } from './slice';

const { reducer } = slice;

export * from './thunks';
export * as slotGamesSelectors from './selectors';
export * from './actions';

export default reducer;
